
let React = require("react");

let Overlay =      require("../../controls/modals/Loading.jsx");
let Confirm =      require("../../controls/modals/Confirm.jsx");

let ToastPage =    require("./ToastPage.jsx");

class MasterPage extends React.Component {

    constructor() {
        super()
        this.state = {
            loading: { show: false, message: "", percent: null },
            confirm: { show: false, message: "" }
        };

        this.setLoading = this.setLoading.bind(this);
        this.setConfirmation = this.setConfirmation.bind(this);

        this.onCancelPopup = this.onCancelPopup.bind(this);
        this.onConfirmPopup = this.onConfirmPopup.bind(this);

        this.loads = {};
    }

    getLoadMessage(){
        return Object.entries(this.loads).map( ([key, value]) => key + ": " + value);
    }

    // If a load ID parameter is given, the load will be added (or removed) from the load stack
    setLoading(showLoading, optionalMessage, loadID, percent = null){
        if (!optionalMessage) optionalMessage = "";

        if(loadID){
            if(showLoading){
                this.loads[loadID] = optionalMessage;
            } else {
                delete this.loads[loadID]
            }
            if(Object.keys(this.loads).length == 0){
                this.setState({loading:{ show: false }});
            } else {
                this.setState({loading:{ show: true, message: this.getLoadMessage(), percent }});
            }
        } else {
            this.setState({loading:{ show: showLoading, message: optionalMessage, percent}});
        }
    }

    setConfirmation(showConfirmation, title, message, onConfirm, options, checkboxes, onDecline, showCancel = true){
        if(onConfirm) this.confirmPopupAction = onConfirm;
        if(onDecline) this.cancelPopupAction = onDecline;
        this.setState({confirm:{ show: showConfirmation, message, title, options, checkboxes, showCancel}});
    }

    onConfirmPopup(option, checkboxValues){
        this.setConfirmation(false);
        if(this.confirmPopupAction) this.confirmPopupAction(option, checkboxValues);
    }

    onCancelPopup(){
        this.setConfirmation(false);
        if(this.cancelPopupAction) this.cancelPopupAction();
    }

    render() {
        const { renderPage } = this.props;

        const {
            confirm
        } = this.state;

        // TODO this page should be generic.  Toast is a notification item,
        // it should not know what a 'hub' is.

        return(
            <React.Fragment>
                <ToastPage
                    {...this.props}
                    setLoading={this.setLoading}
                    setConfirmation={this.setConfirmation}


                    renderPage={({onOpen: onOpenToast, onClose: onCloseToast, setHubInfo, childrenMethods,
                                    currentHub, currentHubMembers, currentHubInvites, setCurrentHub, setCanHaveMoreHubs, totalHubsAllowed}) =>

                        <React.Fragment>
                            { renderPage({
                                setHubInfo,
                                currentHub,
                                onOpenToast,
                                onCloseToast,
                                childrenMethods,
                                currentHubMembers,
                                currentHubInvites,
                                setCurrentHub,
                                setCanHaveMoreHubs,
                                totalHubsAllowed,
                                setLoading:this.setLoading,
                                setConfirmation:this.setConfirmation,
                                history: this.props.history,
                                handleError: this.props.handleError
                            })}

                            <Overlay message={this.state.loading.message} show={this.state.loading.show} percent={this.state.loading.percent} />

                            <Overlay show={this.state.confirm.show}>
                                <Confirm title={this.state.confirm.title} message={this.state.confirm.message} options={confirm.options} checkboxes={confirm.checkboxes} onCancel={this.onCancelPopup} onConfirm={this.onConfirmPopup} showCancel={this.state.confirm.showCancel}/>
                            </Overlay>
                        </React.Fragment>
                    }
                />
            </React.Fragment>
        );
    }
}

module.exports = MasterPage;
